import { createReducer, on } from '@ngrx/store';
import * as DeleteDestinationActions from '../actions/delete-destination.actions';
import {Destination} from '../../../services/api/destinations/destination.model';

export const deleteDestinationFeatureKey = 'deleteDestination';

export interface State {
  record: Destination | null;
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(DeleteDestinationActions.deleteDestination, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(DeleteDestinationActions.deleteDestinationSuccess, (state, action) => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(DeleteDestinationActions.deleteDestinationFailure, (state, action) => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(DeleteDestinationActions.clearDeleteDestinationState, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);

